/**
 * Generated by orval v8.19.0 🍺
 * Do not edit manually.
 * Rock&Run Admin API
 * OpenAPI spec version: 1.0
 */

/**
 * 결제 상태
 */
export type PaymentStatus = (typeof PaymentStatus)[keyof typeof PaymentStatus];

export const PaymentStatus = {
	PENDING: 'PENDING',
	COMPLETED: 'COMPLETED',
	FAILED: 'FAILED',
	CANCELED: 'CANCELED',
	REFUND_REQUESTED: 'REFUND_REQUESTED',
	REFUNDED: 'REFUNDED',
	PARTIAL_REFUNDED: 'PARTIAL_REFUNDED'
} as const;
